import { useCallback, useState } from 'react'

import { VariantData } from '../models'
import { ExperimentsHelper } from '../lib'
import { useCoinUserEvents } from '../../tracking'

export const hasExperiment = (name: string) => !!ExperimentsHelper.getExperiment(name)

export const selectVariantForExperiment = <T>(name: string, variants: Record<string, T>, defaultValue: T): T => {
  const variant = ExperimentsHelper.getSelectedVariant(name)
  if (variants[variant?.name ?? '']) {
    return variants[variant?.name ?? '']
  }
  return defaultValue
}

export const useExperiments = <T>(name: string, experiments: VariantData[]) => {
  const [activeExperiment] = useState(ExperimentsHelper.calculateExperiment(name, true, experiments, useCoinUserEvents()))

  const selectVariant = useCallback((variants: Record<string, T>, defaultValue: T) => {
    if (activeExperiment?.name && activeExperiment?.name in variants) {
      return variants[activeExperiment?.name]
    }
    return defaultValue
  }, [activeExperiment?.name])

  return {
    experimentName: name,
    selectVariant,
    hasExperiment
  }
}
